import { initialize } from 'redux-form'
import modalProps from '../modalProps'
import { FORM_NAME } from '../Form'

export default () => (dispatch) => {
  
  const { valuationDate } = modalProps()

  if (valuationDate) {

    dispatch(initialize(FORM_NAME, valuationDate))
    
  } else {

    dispatch(initialize(FORM_NAME, {}))

  }

}
